export function getUrlSearchParam(paramName, defaultValue) {
    const params = new URLSearchParams(window.location.search);

    if (params.has(paramName)) {
        return params.get(paramName);
    }

    return defaultValue;
}
